import { render, staticRenderFns } from "./WorkModal.vue?vue&type=template&id=afc5a6cc&"
import script from "./WorkModal.vue?vue&type=script&lang=js&"
export * from "./WorkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports